<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        {{this.$route.meta.title}}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exporthistoryxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label>CustCode</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustCode" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No. Identitas</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.nomoridentitas" disabled></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Debitur</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.CustName" disabled></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-col>
            <b-input-group>
              <b-input-group-prepend>
                <label>No. Telp</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.PhoneNo" disabled></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Alamat Debitur</label>
              </b-input-group-prepend>
              <b-form-textarea
                v-model="model.alamatktp"
                rows="2"
                max-rows="6"
                disabled
              ></b-form-textarea>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Kota</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.City" disabled></b-form-input>
            </b-input-group>
          </b-col>
        </b-col>
      </b-row>
      <hr />
      <b-card border-variant="info" align="center" no-body>
        <template v-slot:header>
          <h6>Daftar Kolektor atas Debitur</h6>
        </template>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          small
          style="font-size:smaller;"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :key="tblData.limit"
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(nomor)="data">{{ data.index +1}}</template>
          <template v-slot:cell(startdate)="data">{{ data.item.startdate|moment("YYYY-MM-DD")}}</template>
          <template v-slot:cell(enddate)="data">
              <span v-if="data.item.enddate">{{ data.item.enddate|moment("YYYY-MM-DD")}}</span>
              <span v-else>Sekarang</span>
        </template>
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries
            </div>
          </b-col>
          <b-col cols="4">
            <b-form-group label-cols="3" label style="margin-top:0 !important;">
              <b-input-group>
                <b-input-group-prepend class="mr-2">
                  <label>Limit per page</label>
                </b-input-group-prepend>
                <div class="d-flex">
                  <b-form-select
                    :options="[10, 15, 20, 25,50,75,100]"
                    :plain="true"
                    v-model="tblData.limit"
                    size="sm"
                    style="width:80px"
                  />
                </div>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import debitur from "../../apis/debitur";
toastr.init();

export default {
  data() {
    return {
      model: { nasabahkey: "" },
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
      },
      isBusy: false
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No."
        },
        {
          key: "crewnik",
          label: "NIK Kolektor",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "collector_name",
          label: "Nama Kolektor",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "startdate",
          label: "Start Date",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "enddate",
          label: "End Date",
          thClass: "text-center",
          sortable: true
        }
      ];
      return fields;
    }
  },
  created: async function() {
    if (this.$route.params.nasabahkey) {
      //toastr.info("Loading Collection History, please wait");
      try {
        this.model.nasabahkey = this.$route.params.nasabahkey;
        this.getData();
        //toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    }
  },
  methods: {
    async getData() {
      const [datadebitur, datacollection] = await debitur.historycollection(this.model.nasabahkey);
      this.model = datadebitur;
      this.tblData.items = datacollection;
    },
    async exporthistoryxls() {
      try {
        console.log("#this.tblDataX: ", this.tblData);
        await debitur.exporthistoryxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.go(-1);
    }
  }
};
</script>
